var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{staticClass:"portal",attrs:{"selector":"#attend-portal"}},[_c('AttendPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }